import { render, staticRenderFns } from "./ProfileCommon.vue?vue&type=template&id=20126d0c"
import script from "./ProfileCommon.vue?vue&type=script&lang=ts"
export * from "./ProfileCommon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports